export default "__VITE_ASSET__TtAJK6qy__"